import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7678f566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "profile-title" }, "个人信息", -1))
const _hoisted_3 = { class: "profile-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-item-title" }, "昵称", -1))
const _hoisted_5 = { class: "profile-item-value" }
const _hoisted_6 = { class: "profile-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-item-title" }, "姓名", -1))
const _hoisted_8 = { class: "profile-item-value" }
const _hoisted_9 = { class: "profile-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-item-title" }, "学段学科", -1))
const _hoisted_11 = {
  key: 0,
  class: "profile-item-value"
}
const _hoisted_12 = {
  key: 1,
  class: "profile-item-value"
}
const _hoisted_13 = { class: "profile-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-item-title" }, "更新日期", -1))
const _hoisted_15 = { class: "profile-item-value" }

import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { UserInfo } from '@/types'
import { getDept, setUserDept } from '@/api/user'
import UserDeptCascader from '@/components/common/UserDeptCascader.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const userInfo = computed(() => store.getters.userInfo as UserInfo)
const userDeptPath = ref('')

const fetchUserDeptPath = async (dept: string) => {
  try {
    const res = await getDept(dept)
    const remarkString = res.result.remark
    const remark = JSON.parse(remarkString.replace(/'/g, '"'))
    if (remark && remark.period && remark.subject) {
      const {
        period,
        subject
      } = remark
      userDeptPath.value = `${period.label} / ${subject.label}`
    } else {
      userDeptPath.value = '未设置' // or handle accordingly
    }
  } catch (error) {
    console.error('Error fetching department path:', error)
  }
}

const handleSetUserDept = async (dept: string) => {
  try {
    userInfo.value.dept = dept
    await setUserDept({
      id: userInfo.value.id,
      dept
    })
  } catch (error) {
    console.error('Error setting user department:', error)
  }
}

// Watch for changes in userInfo.dept to update userDeptPath
watch(() => userInfo.value.dept, async (newDept) => {
  if (newDept) {
    await fetchUserDeptPath(newDept)
    await store.dispatch('user/getInfo')
  } else {
    userDeptPath.value = ''
  }
}, { immediate: true })

const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleString() || '未设置'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dl", null, [
      _hoisted_2,
      _createElementVNode("dd", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(userInfo.value.username || '未设置'), 1)
      ]),
      _createElementVNode("dd", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(userInfo.value.name || '未设置'), 1)
      ]),
      _createElementVNode("dd", _hoisted_9, [
        _hoisted_10,
        (userInfo.value.dept)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(userDeptPath.value), 1))
          : _createCommentVNode("", true),
        (!userInfo.value.dept)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(UserDeptCascader, { onChange: handleSetUserDept })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("dd", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(formatDate(userInfo.value.update_datetime) || '未设置'), 1)
      ])
    ])
  ]))
}
}

})